import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addShiftAssignment,
  addTeamAssignment,
  fetchStaffDutyCalendar,
  removeShiftAssignment,
} from "../../apis/staffDutyCalendar";

import type { ShiftType } from "../../utils/types/staffDutyCalendar";

export const fetchStaffDutyCalendarData = createAsyncThunk(
  "staffDutyCalendar/fetch",
  async (_args: string[] | { force?: boolean }, { rejectWithValue }) => {
    try {
      return await fetchStaffDutyCalendar();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (args, { getState }) => {
      const state = getState() as any;
      return (!Array.isArray(args) && args.force) || !state.staffDutyCalendar.isDataFetched;
    },
  }
);

export const addShiftAssignmentData = createAsyncThunk(
  "staffDutyCalendar/addShiftAssignment",
  async (
    data: { date: string; shift: ShiftType; personId: string },
    { rejectWithValue }
  ) => {
    try {
      return await addShiftAssignment(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTeamAssignmentData = createAsyncThunk(
  "staffDutyCalendar/addTeamAssignment",
  async (
    data: { date: string; shift: ShiftType; teamId: string },
    { rejectWithValue }
  ) => {
    try {
      return await addTeamAssignment(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeShiftAssignmentData = createAsyncThunk(
  "staffDutyCalendar/removeShiftAssignment",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await removeShiftAssignment(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
